jQuery.event.special.touchstart = {
  setup: function (_, ns, handle) {
    if (ns.includes("noPreventDefault")) {
      this.addEventListener("touchstart", handle, { passive: false });
    } else {
      this.addEventListener("touchstart", handle, { passive: true });
    }
  },
};

jQuery.event.special.touchmove = {
  setup: function (_, ns, handle) {
    if (ns.includes("noPreventDefault")) {
      this.addEventListener("touchmove", handle, { passive: false });
    } else {
      this.addEventListener("touchmove", handle, { passive: true });
    }
  },
};

var searchWrapper = $(".search-form-wrapper");
var searchInput = $(".search-form-wrapper .search-input");
var searchIcon = $(".search-toggle");
searchIcon.on("click", function () {
  searchWrapper.toggleClass("show");

  if (searchWrapper.hasClass("show")) {
    searchInput.focus();
    searchIcon.attr("aria-expanded", "true");
  } else {
    searchIcon.attr("aria-expanded", "false");
    searchInput.blur();
  }
});

/**** Main menu ****/

$(".dropdown-toggle").dropdown();

function checkWidth() {
  if ($(window).width() < 975) {
    $(".navi li ul").hide();
  } else {
    $(".navi li ul").attr("style", "");
  }
}

checkWidth();

$(window).on("resize", function () {
  checkWidth();
  $("a.colapse").hide();
  $("a.expand").show();
});

$(".navi li").each(function () {
  var li = $(this);
  if (li.find("ul li").length > 0) {
    li.append(
      "<a href='javascript:;' rel='nofollow noopener' class='expand icon-expand' onclick='return false;'></a>"
    );
    li.append(
      "<a href='javascript:;' rel='nofollow noopener' class='colapse icon-collapse' onclick='return false;'></a>"
    );
  }
});

$("body").on("click", "a.expand", function () {
  $(this).hide().next().show();
  $(this).parent().siblings().find("ul").slideUp();
  $(this).parent().siblings().find("a.expand").show();
  $(this).parent().siblings().find("a.colapse").hide();
  $(this)
    .parent()
    .find(">ul")
    .addClass("expanded")
    .stop(true, true)
    .slideDown();
});

$("body").on("click", "a.colapse", function () {
  $(this)
    .parent()
    .find("ul")
    .removeClass("expanded")
    .stop(true, true)
    .slideUp();
  $(this).parent().find("a.colapse").hide();
  $(this).parent().find("a.expand").show();
});

$(".hamburger, .hamburger.mobile").on("click", function () {
  var isOpen = $("body").hasClass("navi-open");

  if (isOpen) {
    $(".hamburger, .hamburger.mobile")
      .removeClass("is-active")
      .attr("aria-expanded", "false");
    $(".mobile-menu").removeClass("is-active").attr("aria-hidden", "true");
    $(".header-container, .navigation-wrapper, body").removeClass("navi-open");
  } else {
    $(".hamburger, .hamburger.mobile")
      .addClass("is-active")
      .attr("aria-expanded", "true");
    $(".mobile-menu").addClass("is-active").attr("aria-hidden", "false");
    $(".header-container, .navigation-wrapper, body").addClass("navi-open");
  }
});

$(".show-more").on("click", function () {
  var $btn = $(this);
  var $li = $btn.closest("li.level1");
  var $submenu = $li.find(".wrapper-level2, ul.level2").first();

  $submenu.toggleClass("open");
  $li.toggleClass("open");

  var isOpen = $li.hasClass("open");
  $btn.attr("aria-expanded", isOpen);
  $submenu.prop("hidden", !isOpen);
});

/**** Main menu end ****/

function wrapTextWithAnimation(selector, iconClass) {
  $(selector).each(function () {
    var originalText = $(this)
      .contents()
      .filter(function () {
        return this.nodeType === 3;
      })
      .text()
      .trim();

    if (originalText) {
      $(this).html(
        '<div class="slide-in-bottom"><span aria-hidden="true" data-hover="' +
          originalText +
          '">' +
          originalText +
          '<div class="' +
          iconClass +
          '"></div>' +
          "</span></div>"
      );
    }
  });
}

wrapTextWithAnimation(".btn-primary", "icon-more");
wrapTextWithAnimation(".btn-secondary", "icon-more-blue");
wrapTextWithAnimation(".slideup", "icon-more");
wrapTextWithAnimation(".slideup-black", "icon-more-black");
